import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'quill/dist/quill.snow.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './utils/pushNotifications';

registerServiceWorker();

function setupChunkErrorReload() {
  const shouldReload = (message = '') => {
    const msg = String(message || '');
    return msg.includes('Loading chunk') || msg.includes('ChunkLoadError');
  };

  window.addEventListener('error', (event) => {
    if (shouldReload(event?.message)) {
      window.location.reload();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const message = reason?.message || reason?.toString?.() || '';
    if (shouldReload(message)) {
      window.location.reload();
    }
  });
}

setupChunkErrorReload();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
